import { Injectable } from '@angular/core';

// Models
import { User } from 'src/app/modules/account/models/user';

/**
 * This service is in charge of managing the information that will only
 * be required within the angular application.
 */
@Injectable()
export class LocalStorageService {
    constructor() {}

    /**
     * Retrieves a user from the local Storage.
     */
    public getUser(): User {
        const userData = localStorage.getItem('userdata');

        return userData ? Object.assign(new User(), JSON.parse(userData)) : userData;
    }

    /**
     * Saves a user into the local storage.
     */
    public setUser(user: User): void {
        localStorage.setItem('userdata', JSON.stringify(user));
    }

    /**
     * Remove the user information from the local storage.
     */
    public removeUser(): void {
        localStorage.removeItem('userdata');
    }

    /**
     * Retrieves a current account from the local Storage.
     */
    public getAccount(): string {
        const userAccount = localStorage.getItem('useraccount');

        return userAccount ? userAccount : '';
    }

    /**
     * Saves a current account into the local storage.
     */
    public setAccount(account: number): void {
        localStorage.setItem('useraccount', JSON.stringify(account));
    }

    /**
     * Remove the current account from the local storage.
     */
    public removeAccount(): void {
        localStorage.removeItem('useraccount');
    }
}
